import React, { useEffect, useRef } from 'react';
import './LogsPopup.css';

const LogsPopup = ({ isOpen, onClose, logs, isLoading }) => {
  const logsEndRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to bottom when new logs arrive
    if (logsEndRef.current) {
      logsEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs]);

  if (!isOpen) return null;

  return (
    <div className="logs-popup-overlay" onClick={onClose}>
      <div className="logs-popup-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logs-popup-header">
          <h2>📋 Operation Logs</h2>
          {!isLoading && (
            <button className="close-btn" onClick={onClose}>✕</button>
          )}
        </div>

        <div className="logs-popup-content">
          <div className="logs-container">
            {logs.length === 0 ? (
              <div className="logs-empty">
                <span className="spinner"></span>
                <p>Waiting for logs...</p>
              </div>
            ) : (
              <div className="logs-list">
                {logs.map((log, idx) => (
                  <div
                    key={idx}
                    className={`log-entry log-${log.type || 'info'}`}
                  >
                    <span className="log-icon">
                      {log.type === 'error' && '❌'}
                      {log.type === 'success' && '✅'}
                      {log.type === 'warning' && '⚠️'}
                      {(log.type === 'info' || !log.type) && 'ℹ️'}
                    </span>
                    <span className="log-message">{log.message}</span>
                  </div>
                ))}
                <div ref={logsEndRef} />
              </div>
            )}
          </div>
        </div>

        {isLoading && (
          <div className="logs-popup-footer">
            <div className="loading-indicator">
              <span className="spinner-small"></span>
              <span>Processing...</span>
            </div>
          </div>
        )}

        {!isLoading && logs.length > 0 && (
          <div className="logs-popup-footer">
            <button className="close-btn-footer" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogsPopup;
